import { PayloadAction } from 'app/core/models/action';
import { Location } from 'app/profile/models/profile.model';
import { UnitOfMeasure } from 'app/profile/models/site.model';

export const GET_MANUFACTURING_LOCATIONS = "[SITE] GET_MANUFACTURING_LOCATIONS";
export const GET_MANUFACTURING_LOCATIONS_SUCCESS = "[SITE] GET_MANUFACTURING_LOCATIONS_SUCCESS";
export const GET_UNIT_OF_MEASURE = "[SITE] GET_UNIT_OF_MEASURE_LOCATIONS";
export const GET_UNIT_OF_MEASURE_SUCCESS = "[SITE] GET_UNIT_OF_MEASURE_SUCCESS";

export class GetManufacturingLocations implements PayloadAction {
    readonly type = GET_MANUFACTURING_LOCATIONS;
    constructor(public payload: string) {}
}
export class GetManufacturingLocationsSuccess implements PayloadAction {
    readonly type = GET_MANUFACTURING_LOCATIONS_SUCCESS;
    constructor(public payload: Location[]) {}
}

export class GetUnitOfMeasure implements PayloadAction {
    readonly type = GET_UNIT_OF_MEASURE;
    constructor() {}
}
export class GetUnitOfMeasureSuccess implements PayloadAction {
    readonly type = GET_UNIT_OF_MEASURE_SUCCESS;
    constructor(public payload: UnitOfMeasure[]) {}
}

export type SiteActions =
    | GetManufacturingLocations
    | GetManufacturingLocationsSuccess
    | GetUnitOfMeasure
    | GetUnitOfMeasureSuccess;
